export enum DateTransformType {
    Locale = 'LL',
    Format = 'L',
}
